<input type="hidden" id="adminVerified" data-toggle="modal" data-target="#adminVerify">

<!-- The Modal -->
<div class="modal fade" data-backdrop="static" id="adminVerify">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">

              <!-- Modal body -->
              <div class="modal-body">
                  <h2>Thank You for Registering with DaktarZ.Please wait for admin to approve your Profile.If you have any queries</h2> 
                      <h3>Please write us  at support@daktarz.com</h3>
                      <button (click)="logout()" class="btn btn-small btn-style text-center" style="margin: 17px auto 0;display: block;">Logout</button>
              </div>
          </div>
      </div>
  </div>